function Header({ getData }) {
  return (
    <header className="df">
      <button className="link en" onClick={() => getData("en")}>
        EN
      </button>
      <br />

      <button className="link cn" onClick={() => getData("cn")}>
       中文
      </button>
    </header>
  );
}
export default Header;
